"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderBar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderBar = _styledComponents.default.div.withConfig({
  displayName: "HeaderBar",
  componentId: "sc-5cxwo2-0"
})(["position:relative;background:", ";padding:24px 0;margin-bottom:24px;& > *{position:relative;}@media ", "{padding:16px 0;margin-bottom:16px;}&::before{content:'';display:block;position:absolute;background:", ";top:0;bottom:0;z-index:0;width:100vw;left:50%;transform:translateX(-50%);}"], (0, _helpers.color)('neutral-1'), (0, _helpers.breakpoint)('maxMobile'), (0, _helpers.color)('neutral-1'));

exports.HeaderBar = HeaderBar;